var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-xs-12 col-sm-6 col-md-4 col-print-6" }, [
    _c("div", { staticClass: "panel panel-primary panel-travel" }, [
      _c("a", { attrs: { href: _vm.url, target: _vm.target } }, [
        _c(
          "div",
          {
            staticClass: "panel-image",
            staticStyle: { "aspect-ratio": "16/9" },
          },
          [
            _vm.tripData.overrides && _vm.tripData.overrides.imagePath
              ? _c("responsive-concrete-image", {
                  attrs: {
                    src: _vm.tripData.overrides.imagePath,
                    "available-thumbnails": _vm.tripData.overrides.imagePaths,
                    "aspect-ratio": 16 / 9,
                    "img-class": "travel-preview-picture img-responsive",
                  },
                })
              : _vm.tripData.bilder
              ? _c("responsive-image", {
                  attrs: {
                    src: _vm.tripData.bilder.jpg_fallback_16x9,
                    "src-xs": _vm.tripData.bilder.img800_16x9,
                    "src-sm": _vm.tripData.bilder.img400_16x9,
                    "src-md": _vm.tripData.bilder.img400_16x9,
                    "src-lg": _vm.tripData.bilder.img400_16x9,
                    "fixed-aspect-ratio": 16 / 9,
                    "img-class": "travel-preview-picture img-responsive",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.tripData.overrides || !_vm.tripData.overrides.hideLabels
              ? _c("div", { staticClass: "panel-image-overlays" }, [
                  _vm.tripData.overrides &&
                  _vm.tripData.overrides.icon &&
                  _vm.tripData.overrides.icon != ".no icon"
                    ? _c("i", {
                        class:
                          "icon " +
                          _vm.tripData.overrides.icon +
                          " circle icon-overlay-right",
                      })
                    : _vm.tripData.icon && _vm.tripData.icon != ".no icon"
                    ? _c("i", {
                        class:
                          "icon " +
                          _vm.tripData.icon +
                          " circle icon-overlay-right",
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isGuaranteed
                    ? _c("div", { staticClass: "label-guaranteed" }, [
                        _vm._v(
                          "\n            Alle Abreisen garantiert\n          "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isFullyBooked
                    ? _c("div", { staticClass: "label-soldout" }, [
                        _vm._v("\n            Ausgebucht\n          "),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isKoenigsklasse
                    ? _c("div", { staticClass: "label-koenigsklasse" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isKomfortklasse
                    ? _c("div", { staticClass: "label-komfortklasse" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tripData.code
                    ? _c(
                        "div",
                        {
                          staticClass: "travel-remember",
                          class: { selected: _vm.isRemembered },
                          attrs: {
                            "data-code": _vm.tripData.code,
                            title: _vm.isRemembered
                              ? "Von Merkliste entfernen"
                              : "Auf Merkliste setzen",
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.toggleRemember()
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "icon very-small icon-pin" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "text" }, [
                            _vm._v("Reise gemerkt"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "panel-body" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12" }, [
              _c("div", { staticClass: "panel-content" }, [
                _vm.tripData.overrides && _vm.tripData.overrides.content
                  ? _c(
                      "div",
                      [
                        _vm.tripData.schwierigkeitsgrad
                          ? _c("requirement-rating", {
                              attrs: {
                                title: "Anforderungsprofil",
                                rating: _vm.tripData.schwierigkeitsgrad,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(_vm.tripData.overrides.content),
                          },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      [
                        _vm.tripData.laender
                          ? _c("div", { staticClass: "country-wrapper" }, [
                              _c("p", { staticClass: "country" }, [
                                _vm._v(_vm._s(_vm.concatCountries)),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("h4", [_vm._v(_vm._s(_vm.tripData.tdbez))]),
                        _vm._v(" "),
                        _vm.tripData.abreisedatentext
                          ? _c("p", { staticClass: "termine" }, [
                              _vm._v(_vm._s(_vm.tripData.abreisedatentext)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.tripData.schwierigkeitsgrad
                          ? _c("requirement-rating", {
                              attrs: {
                                title: "Anforderungsprofil",
                                rating: _vm.tripData.schwierigkeitsgrad,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", { staticClass: "description" }, [
                          _vm._v(_vm._s(_vm.tripData.beschreibung)),
                        ]),
                      ],
                      1
                    ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.tripData.overrides && _vm.tripData.overrides.promoContent
          ? _c("div", {
              staticClass: "panel-highlighted",
              class: "highlight-" + _vm.tripData.overrides.promoColorSet,
              domProps: {
                innerHTML: _vm._s(_vm.tripData.overrides.promoContent),
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "panel-footer" }, [
          _c("span", {
            staticClass: "btn btn-primary btn-arrow col-xs-12",
            domProps: { innerHTML: _vm._s(_vm.button) },
          }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }